// extracted by mini-css-extract-plugin
export default {"fs":"_5c1f1754ff _284cd1a467"};